import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shrink has-text-right" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-left" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right" }, null, -1)
const _hoisted_4 = { class: "shrink" }
const _hoisted_5 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RemoveModal = _resolveComponent("RemoveModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, [
      _createVNode(_component_router_link, {
        to: { name: 'dataset-details', params: { datasetId: _ctx.elementSet.dataset.id } },
        title: "Dataset details"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.elementSet.dataset.name), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("td", null, _toDisplayString(_ctx.elementSet.set), 1),
    _createElementVNode("td", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.elementSet.previous ? 'router-link' : 'span'), {
        class: _normalizeClass(!_ctx.elementSet.previous ? 'has-text-grey' : ''),
        to: _ctx.elementSet.previous ? { name: 'element-details', params: { id: _ctx.elementSet.previous } } : '',
        title: "Go to the previous element in this dataset and set"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class", "to"])),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.elementSet.next ? 'router-link' : 'span'), {
        class: _normalizeClass(!_ctx.elementSet.next ? 'has-text-grey' : ''),
        to: _ctx.elementSet.next ? { name: 'element-details', params: { id: _ctx.elementSet.next } } : '',
        title: "Go to the next element in this dataset and set"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["class", "to"]))
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("a", {
        title: _ctx.title,
        class: "icon is-pulled-right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeElement && _ctx.removeElement(...args)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["icon-remove-square", _ctx.canRemove ? 'has-text-danger' : 'has-text-grey']),
          type: "button"
        }, null, 2)
      ], 8, _hoisted_5)
    ]),
    (_ctx.elementSet.dataset && _ctx.elementSet.set)
      ? (_openBlock(), _createBlock(_component_RemoveModal, {
          key: 0,
          modelValue: _ctx.removeElementModal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.removeElementModal) = $event)),
          dataset: _ctx.elementSet.dataset,
          set: _ctx.elementSet.set,
          element: _ctx.element
        }, null, 8, ["modelValue", "dataset", "set", "element"]))
      : _createCommentVNode("", true)
  ], 64))
}